/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MicroChevronRight = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.9401 11.9952L5.96026 19.9747L8.11559 22.1301L16.0955 14.1505L18.0351 11.9952L16.0955 9.83985L8.11529 1.85999L5.95996 4.01532L13.9401 11.9952Z"
                        fill={color}
                    />
                </svg>
        );
    };
